import * as React from 'react'
import { useTranslation } from 'react-i18next'

import chartColors from 'assets/styles/scss/shared/_chart-colors.module.scss'
import styles from 'components/Shared/Charts/LegendTextFormatter/LegendTextFormatter.module.scss'

type LegendText = {
  color: string
  translationKey: string
  shouldTranslate?: boolean
}

/**
 * Make sure translationKey is present in charts.json if shouldTranslate is true
 */

export const LegendTextFormatter = ({
  color,
  translationKey,
  shouldTranslate = false,
}: LegendText) => {
  const { t } = useTranslation()

  return (
    <div className={styles.flexContainer}>
      <div
        style={{
          backgroundColor: color,
        }}
        className={styles.legendDot}
      />
      <div
        style={{
          color: chartColors.black,
        }}
        className={styles.legendLabel}
      >
        {shouldTranslate ? t(`charts.${translationKey}`) : translationKey}
      </div>
    </div>
  )
}
